import { SchemaModelFieldType } from '@smx-ui-model/types';
import { Form, InputNumber } from 'antd';
import * as React from 'react';
import { memo } from 'react';

interface FieldNumberProps {
    field: SchemaModelFieldType;
}

export const FieldNumber: React.FC<FieldNumberProps> = ({ field }) => {
    return (
        <Form.Item label={field.title} name={field.name}>
            <InputNumber disabled={field.isReadonly} />
        </Form.Item>
    );
};

export default memo(FieldNumber);
